<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ack-title"><a id="pagevii">Acknowledgements</a></h2><a id="pagevii">
<p class="noindent">As with all of my projects, this book would not have been possible without the generous help of many friends. Instrumental to the completion of this book were Dana Bell, Scott Taylor the archivists at the Mack Museum and Rock Island Arsenal, US Army Engineer School History Office, the Ordnance Museum, the members of the National Dusters, Quads and Searchlights Association, the FCA North America Archives, Vintage Power Wagons, David Bundy, David Viscardi, Doug Kibbey, Mike Weaver, Carl T. Heller, Chris Harlow, William Powis, James Lyles, John Adams-Graf, Steve Zaloga, Mike Haines, the staff and volunteers at the Patton Museum, the late Fred Crismon and Eric Mueller, and the staff at the National Archives and TACOM LCMC History Office. Most importantly, I am blessed to have the help and support of my wife Denise, for which I am eternally grateful.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?6a094f47